import { useEffect, useState } from 'react';
import PMGProjectIcon from '../../assets/icons/pmg-project.svg';
import Button from '../../components/Button/Button';
import CustomPagination from '../../components/Common/CustomPagination/CustomPagination';
import CustomTable from '../../components/Common/CustomTable/CustomTable';
import { useDispatch, useSelector } from 'react-redux';
import { addIoUnitMapping, deleteIoUnitMapping, getIoUnitMappingListing } from '../../redux/adminUnitReportSlice/adminUnitReportSlice';
import openNotification from '../../components/Common/OpenNotification';
import AddIoUnitMapping from '../../components/Modals/AddIoUnitMapping';
import { ReactComponent as DeleteIcon } from '../../assets/icons/trash.svg'; // ensure correct import
import { PATHNAME } from '../../pathname';
import { useNavigate } from 'react-router-dom';
import SearchBar from '../../components/Common/SearchBar/SearchBar';

const IoUnitMapping = () => {
        const [searchValue, setSearchValue] = useState('');
        const [currentPage, setCurrentPage] = useState(1);
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [editProject, setEditProject] = useState({});
        const dispatch = useDispatch();
        const navigate = useNavigate();
        const { ioUnitMappingListing, totalIoUnitMappingListing } = useSelector((state) => state.unitReport);

        const handleAdd = async (formData) => {
                let response;

                response = await dispatch(addIoUnitMapping(formData));

                const status = response?.payload?.status;

                if (status === 'success') {
                        dispatch(
                                getIoUnitMappingListing({
                                        page: currentPage,
                                        limit: '10',
                                        search: searchValue,
                                }),
                        );
                        openNotification('success', editProject?.IO_NO ? 'Updated' : 'Added', 'Success');
                        setIsModalOpen(false); // ✅ Only close on success
                }

                return { status }; // ✅ Return status for child to handle
        };

        const handleDelete = async (record) => {
                const response = await dispatch(
                        deleteIoUnitMapping({
                                IO_NO: record.IO_NO,
                                REV_NO: record.REV_NO,
                                MNF_UNIT: record.MNF_UNIT,
                        }),
                );
                const status = response?.payload?.status;

                if (status === 'success') {
                        dispatch(
                                getIoUnitMappingListing({
                                        page: currentPage,
                                        limit: '10',
                                        search: searchValue,
                                }),
                        );
                }
        };

        const pageSize = 10; // Items per page
        const columns = [
                {
                        title: 'Unit Name',
                        dataIndex: 'UNIT_NAME',
                        key: 'UNIT_NAME',
                        width: 200,
                        render: (text, record) => (
                                <div className="flex items-center justify-between gap-2">
                                        <span>{text}</span>
                                        <DeleteIcon
                                                className="text-red-500 cursor-pointer hover:opacity-80"
                                                onClick={() => handleDelete(record)}
                                        />
                                </div>
                        ),
                },
                {
                        title: 'IO Number',
                        dataIndex: 'IO_NO',
                        key: 'IO_NO',
                        width: 180,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'Revision Number',
                        dataIndex: 'REV_NO',
                        key: 'REV_NO',
                        width: 150,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'Manufacturing Unit',
                        dataIndex: 'MNF_UNIT',
                        key: 'MNF_UNIT',
                        width: 150,
                        render: (text) => <div className="text-right">{text}</div>,
                },
        ];

        useEffect(() => {
                dispatch(
                        getIoUnitMappingListing({
                                page: currentPage,
                                limit: '10',
                                search: searchValue,
                        }),
                );
        }, [currentPage, searchValue]);

        return (
                <div className="pb-14">
                        <div className="px-5 flex flex-col gap-6 pt-4">
                                <div className="flex gap-3">
                                        {/* <img
                                                src={PMGProjectIcon}
                                                alt="region"
                                        /> */}
                                        <div>
                                                <div className="font-inter font-semibold text-[18px] leading-[24px] tracking-[0%] text-[#101828]">IO UNIT MAPPING</div>
                                                <div className="font-inter font-normal text-[14px] leading-[24px] tracking-[0%] text-[#475467]">List of IO unit mappings</div>
                                        </div>
                                </div>
                                <div className="text-gray-500 text-sm flex justify-start">* All figures are in Rupees (in lakhs).</div>
                                {/* <div className="mt-[32px] flex justify-end gap-4">
                                        <SearchBar
                                                className="!w-[330px] !h-10"
                                                onSearch={setSearchValue}
                                                placeholder="Search by IO No."
                                        />

                                        <div className="flex">
                                                <div className="mr-4 gap-3">
                                                <Button onClick={() => navigate(PATHNAME.ADMIN_UPLOAD_CSV_FILES_IO_UNIT_MAPPING)}
                                                text="Upload"
                                                variant="primary"
                                                />

                                                </div>

                                                <div className="flex gap-[12px]">
                                                <Button
                                                        text="+ Add IO Unit Data"
                                                        variant="primary"
                                                        onClick={() => {
                                                                setIsModalOpen(true);
                                                                setEditProject({});
                                                        }}
                                                />
                                        </div>
                                         
                                        </div>



                                </div> */}

                                <div className="mt-[8px] flex items-center justify-between">
                                        <SearchBar
                                                className="!w-[330px] !h-10"
                                                onSearch={setSearchValue}
                                                placeholder="Search by IO No."
                                        />

                                        <div className="flex items-center gap-3">
                                                <Button
                                                        onClick={() => navigate(PATHNAME.ADMIN_UPLOAD_CSV_FILES_IO_UNIT_MAPPING)}
                                                        text="Upload"
                                                        variant="primary"
                                                />

                                                <Button
                                                        text="+ Add IO Unit Data"
                                                        variant="primary"
                                                        onClick={() => {
                                                                setIsModalOpen(true);
                                                                setEditProject({});
                                                        }}
                                                />
                                        </div>
                                </div>
                                <div className=" flex flex-col gap-6">
                                        <CustomTable
                                                dataSource={ioUnitMappingListing}
                                                columns={columns}
                                        />
                                        <div>
                                                <CustomPagination
                                                        totalItems={totalIoUnitMappingListing}
                                                        pageSize={pageSize}
                                                        currentPage={currentPage}
                                                        setCurrentPage={setCurrentPage}
                                                />
                                        </div>
                                </div>
                                <AddIoUnitMapping
                                        open={isModalOpen}
                                        onCancel={() => {
                                                setIsModalOpen(false);
                                                setEditProject({});
                                        }}
                                        onSubmit={handleAdd}
                                        initialData={editProject}
                                        setEditIoIndasData={setEditProject}
                                />
                        </div>
                </div>
        );
};

export default IoUnitMapping;
